import React, {useState} from "react"
import {useCatalog, useRoomSetup, useSolution, useLocal} from "../../AppContext"
import {Apply} from "./Apply"
import style from "./ItemSwap.css"
import {MOUNTING__CEILING, MOUNTING__FLOOR, MOUNTING__WALL} from "../../Hooks/Catalog"

export const ItemSwap = () => {
    const solution = useSolution()
    const roomSetup = useRoomSetup()
    const catalog = useCatalog()
    const item = solution.getItem()
    const [state, setState] = useState({parentSku: item.parentSku, sku: item.sku})
    const products = catalog.getChangeList(item.mountingSurfaceType, roomSetup.getRoomHeight())

    const onSelect = (parentSku, sku) => {
        setState({parentSku, sku})
    }

    const onApply = () => {
        solution.swapItem(state.parentSku, state.sku)
        solution.handlerUnset()
    }

    return <>
        <div>
            {products.map((product, index) => <Item key={index} product={product} current={state.parentSku} onSelect={onSelect}/>)}
        </div>
        <Apply onClick={onApply}/>
    </>
}


const Item = ({product, current, onSelect}) => {
    const className = current === product.parentSku
        ? `${style.item} ${style.active}`
        : style.item

    const onClick = () => {
        onSelect(product.parentSku, product.sku)
    }

    return <div className={className} onClick={onClick}>
        <Image product={product}/>
        <div className={style.info}>
            <div>
                <div className={style.name}>{product.name}</div>
                <UnitCount product={product}/>
            </div>
            <div>
                <ColorCount product={product}/>
                <ColorList product={product}/>
            </div>
        </div>
    </div>
}

const Image = ({product}) => {
    const solution = useSolution()
    const item = solution.getItem()

    let productImageUrl = product.imageUrl;
    if (product.mountingImageFloorUrl && isToFloor()) {
        productImageUrl = product.mountingImageFloorUrl
    }
    if (product.mountingImageCeilingUrl && isToCeiling()) {
        productImageUrl = product.mountingImageCeilingUrl
    }
    if (product.mountingImageWallUrl && isToWall()) {
        productImageUrl = product.mountingImageWallUrl
    }

    function isToCeiling() {
        return item.mountingSurfaceType === MOUNTING__CEILING
    }

    function isToFloor() {
        return item.mountingSurfaceType === MOUNTING__FLOOR
    }

    function isToWall() {
        return item.mountingSurfaceType === MOUNTING__WALL
    }

    return <div className={style.image} style={{backgroundImage: `url('${productImageUrl}')`}}/>
}

const UnitCount = ({product}) => {
    const local = useLocal()

    return <div className={style.unit}>{local.__("%unitCount% Stück / Packeinheit", {unitCount: product.unitCount})}</div>
}

const ColorCount = ({product}) => {
    const local = useLocal()

    if (!product.colorCount) return null

    return <div className={style.colorCount}>{local.__("in %colorCount% Farben erhältlich", {colorCount: product.colorCount})}</div>
}

const ColorList = ({product}) => {
    if (!product.colorCount) return null

    return <div className={style.colorList}>
        {product.colorList.map((color, index) => {
            return <div key={index} title={color.label} style={{backgroundImage: `url('${color.swatchUrl}')`}}/>
        })}
    </div>
}
